module.exports = __webpack_public_path__ + "static/img/03.c0226a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/03-hyCase/03.png
// module id = /Ks+
// module chunks = 1